// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase:{
  	apiKey: "AIzaSyA89dE4rpms6T9UBxhAy9VUtLenjW3Y5ck",
  authDomain: "rodov-index.firebaseapp.com",
  databaseURL: "https://rodov-index.firebaseio.com",
  projectId: "rodov-index",
  storageBucket: "rodov-index.appspot.com",
  messagingSenderId: "398806918614",
  appId: "1:398806918614:web:4966864fa6bf6e7d557077"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
